import { requestApi } from "../funcitons";

export default {
    getColors: async (project_id) => {
        if (!project_id) {
            return [];
        }
        const res = await requestApi('project-colors/project/' + project_id, 'GET');
        return res.data;
    },

    createColor: async (project_id, color) => {
        const res = await requestApi('project-colors', 'POST', { project_id, color });
        return res.data;
    },

    updateColor: async (id, color) => {
        const res = await requestApi('project-colors/' + id, 'PUT', { color });
        return res.data;
    },
    
    deleteColor: async (id) => {
        const res = await requestApi('project-colors/' + id, 'DELETE');
        return res.data;
    },
}